import React, { useEffect, useRef, useState } from 'react';

import Avatar from '@atlaskit/avatar';

import penEditComment from '../../assets/icon-pen-edit-comment.png';
import seta from '../../assets/icons/icon-arrow-green.png';
import deletIcon from "../../assets/icons/icon-trash-red.png"
import setaGray from '../../assets/icon-arrow-up-comment-gray.png';
import IconCloseGray from "../../assets/icons/icon-close-gray.svg"
import { IconUploads } from '../../assets/icons/iconUploads';
import iconClipGray from "../../assets/icons/icon-clip-gray.png"

import { store } from "react-notifications-component";

import Comment, { CommentAction, CommentAuthor, CommentTime } from '@atlaskit/comment';
import sampleAvatar from '../../assets/arvore-4.png';

import api from '../../services/api';
import ModalTesteGratisAcabou from '../modal/modalFuncaoBloqueada';

import * as S from './styles';
import { Auxiliar, BodyMSpan, H6 } from '../../styles/stylesTypography';
import { theme } from '../../styles/theme';

import identifyErrorMenssage from "../../services/identifyErrorMenssage";
export const USERJSON = JSON.parse(localStorage.getItem('@userinfo'));

const MAX_UPLOAD_BYTES = 10 * 1024 * 1024;
const MAX_IMAGE_DIMENSION = 1600;
const JPEG_QUALITY = 0.8;
const LIMIT_ERROR_CODES = new Set([
  'LIMIT_EXCEEDED',
  'COMMENTS_LIMIT_EXCEEDED',
  'COMMENT_LIMIT_EXCEEDED',
  'FILE_LIMIT_EXCEEDED',
  'ATTACHMENTS_LIMIT_EXCEEDED'
]);

function isLimitExceededPayload(payload) {
  if (!payload) return false;

  if (payload.limitExceeded === true || payload.limitReached === true) {
    return true;
  }

  const code = payload.code || payload.errorCode;
  if (code && LIMIT_ERROR_CODES.has(String(code).toUpperCase())) {
    return true;
  }

  const message = payload.errors || payload.message;
  if (typeof message === 'string') {
    const normalized = message.toLowerCase();
    if (normalized.includes('limite') || normalized.includes('20 mb')) {
      return true;
    }
  }

  if (Array.isArray(payload.errors)) {
    for (const item of payload.errors) {
      if (typeof item === 'string') {
        const normalized = item.toLowerCase();
        if (normalized.includes('limite') || normalized.includes('20 mb')) {
          return true;
        }
      } else if (item && typeof item === 'object') {
        const alerta = item.alerta || item.message || item.error;
        if (typeof alerta === 'string') {
          const normalized = alerta.toLowerCase();
          if (normalized.includes('limite') || normalized.includes('20 mb')) {
            return true;
          }
        }
      }
    }
  }

  return false;
}

function formatarDataHora(date) {
  const d = new Date(date);
  const dia = String(d.getDate()).padStart(2, '0');
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const ano = d.getFullYear();
  const hora = String(d.getHours()).padStart(2, '0');
  const minuto = String(d.getMinutes()).padStart(2, '0');
  return `${dia}/${mes}/${ano}, ${hora}:${minuto}`;
}

function getCommentAttachments(comentario) {
  if (Array.isArray(comentario?.attachments)) {
    return comentario.attachments;
  }
  if (comentario?.attachment) {
    return [comentario.attachment];
  }
  return [];
}

function renderAttachments(attachments) {
  if (!attachments || attachments.length === 0) {
    return null;
  }

  return (
    <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', gap: 6 }}>
      {attachments.map((attachment, index) => {
        if (!attachment) return null;

        const url = attachment.url || attachment.link;
        if (!url) return null;

        const name = attachment.name || attachment.filename || 'Arquivo';
        const type = attachment.mimeType || attachment.type || '';

        if (type.startsWith('image/')) {
          return (
            <a
              key={url || `${name}-${index}`}
              href={url}
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={url}
                alt={name}
                style={{ maxWidth: 220, borderRadius: 4, cursor: 'pointer' }}
              />
            </a>
          );
        }

        return (
          <a
            key={url || `${name}-${index}`}
            href={url}
            target="_blank"
            rel="noreferrer"
            style={{ color: theme.colors.blue.Azul_link, fontFamily: 'Lato', fontSize: 12 }}
          >
            {name || 'Baixar arquivo'}
          </a>
        );
      })}
    </div>
  );
}

function loadImageFromFile(file) {
  return new Promise((resolve, reject) => {
    const imageUrl = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(imageUrl);
      resolve(img);
    };
    img.onerror = (error) => {
      URL.revokeObjectURL(imageUrl);
      reject(error);
    };
    img.src = imageUrl;
  });
}

async function compressImageFile(file) {
  if (!file || !file.type || !file.type.startsWith('image/')) {
    return file;
  }

  if (file.type === 'image/gif') {
    return file;
  }

  const img = await loadImageFromFile(file);
  const maxSide = Math.max(img.width, img.height);
  const scale = maxSide > MAX_IMAGE_DIMENSION ? MAX_IMAGE_DIMENSION / maxSide : 1;
  const width = Math.max(1, Math.round(img.width * scale));
  const height = Math.max(1, Math.round(img.height * scale));

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  const ctx = canvas.getContext('2d');
  if (!ctx) {
    return file;
  }

  ctx.drawImage(img, 0, 0, width, height);

  const targetType = file.type === 'image/png' ? 'image/png' : 'image/jpeg';
  const quality = targetType === 'image/jpeg' ? JPEG_QUALITY : undefined;

  const blob = await new Promise((resolve) => {
    canvas.toBlob(resolve, targetType, quality);
  });

  if (!blob) {
    return file;
  }

  return new File([blob], file.name, { type: blob.type, lastModified: Date.now() });
}

function adicionarRespostaRecursivo(comentarios, id, respostaObj) {
  return comentarios.map(comentario => {
    if (comentario.id === id) {
      return {
        ...comentario,
        replies: [...(comentario.replies || []), respostaObj],
      };
    } else if (comentario.replies && comentario.replies.length > 0) {
      return {
        ...comentario,
        replies: adicionarRespostaRecursivo(comentario.replies, id, respostaObj),
      };
    } else {
      return comentario;
    }
  });
}

function editarComentarioRecursivo(comentarios, id, novoTexto) {
  return comentarios.map(comentario => {
    if (comentario.id === id) {
      return {
        ...comentario,
        content: novoTexto,
        editado: true,
        time: comentario.time,
      };
    } else if (comentario.replies && comentario.replies.length > 0) {
      return {
        ...comentario,
        replies: editarComentarioRecursivo(comentario.replies, id, novoTexto),
      };
    } else {
      return comentario;
    }
  });
}

function excluirComentarioRecursivo(comentarios, id) {
  return comentarios
    .filter(comentario => comentario.id !== id)
    .map(comentario => ({
      ...comentario,
      replies: comentario.replies ? excluirComentarioRecursivo(comentario.replies, id) : [],
    }));
}

function renderComments(
  comentarios,
  responderId,
  setResponderId,
  resposta,
  setResposta,
  adicionarResposta,
  cancelarResposta,
  editarId,
  setEditarId,
  textoEdicao,
  setTextoEdicao,
  salvarEdicao,
  cancelarEdicao,
  profileName,
  nomeUsuario,
  accordionId,
  setAccordionId,
  hoverId,
  setHoverId,
  excluirComentario,
  accordionRef,
  editTextareaRef,
  replySubmittingId,
  setReplySubmittingId,
  editSubmittingId,
  setEditSubmittingId,
  depth = 0
) {
  return comentarios.map(comentario => {
    const isAuthor = comentario.author === nomeUsuario;
    const isHovered = hoverId === comentario.id;
    const isAccordionOpen = accordionId === comentario.id;
    const attachments = getCommentAttachments(comentario);

    return (
      <div
        key={comentario.id}
        onMouseEnter={() => isAuthor && setHoverId(comentario.id)}
        onMouseLeave={() => isAuthor && setHoverId(null)}
        style={{position: 'relative'}}
      >
        <Comment
          avatar={
            <S.NameProfile>
              <BodyMSpan>{profileName}</BodyMSpan>
            </S.NameProfile>
          }
          author={
            <CommentAuthor>
              {comentario.author}
            </CommentAuthor>
          }
          time={
            <CommentTime>
              <Auxiliar color={theme.colors.gray.Cinza_6}>
                {comentario.time} {comentario.editado ? '(Editado)' : ''}
              </Auxiliar>
            </CommentTime>
          }
          content={
            editarId === comentario.id ? (
              <div>
                <div style={{ width: '100%', display: 'flex'}}>
                  <textarea
                    ref={editarId === comentario.id ? editTextareaRef : null}
                    value={textoEdicao}
                    onChange={e => {
                      setTextoEdicao(e.target.value);
                      const el = e.target;
                      el.style.height = 'auto';
                      el.style.height = Math.max(30, Math.min(el.scrollHeight, 200)) + 'px';
                    }}
                    onKeyDown={e => {
                      if (e.key === 'Enter') {
                        const target = e.target;
                        const start = target.selectionStart;
                        const end = target.selectionEnd;
                        if (e.ctrlKey || e.metaKey) {
                          e.preventDefault();
                          const value = target.value;
                          const newValue = value.slice(0, start) + '\n' + value.slice(end);
                          setTextoEdicao(newValue);
                          requestAnimationFrame(() => {
                            const pos = start + 1;
                            if (target.setSelectionRange) {
                              target.setSelectionRange(pos, pos);
                            }
                            target.style.height = 'auto';
                            target.style.height = Math.max(30, Math.min(target.scrollHeight, 200)) + 'px';
                          });
                          return;
                        }
                        e.preventDefault();
                        if (textoEdicao.trim() && textoEdicao !== comentario.content) {
                          salvarEdicao(comentario.id);
                        }
                      }
                    }}
                    placeholder="Editar comentário..."
                    style={{ width: '90%',marginRight: 8, fontFamily: 'Lato', resize: 'none', minHeight: 30 }}
                    rows={1}
                  />

                  <S.Close onClick={cancelarEdicao}>
                    <img src={IconCloseGray} alt="Icone de fechar" />
                  </S.Close>

                  {editSubmittingId === comentario.id ? (
                    <div style={{ display: 'flex', marginBottom: '8px', marginLeft: '8px' }}>
                      <S.LoadingComment />
                    </div>
                  ) : (
                    <img
                      src={seta}
                      alt="seta"
                      style={{
                        width: '24px',
                        height: '24px',
                        marginLeft: '8px',
                        cursor: textoEdicao.trim() && textoEdicao !== comentario.content ? 'pointer' : 'not-allowed',
                        opacity: textoEdicao.trim() && textoEdicao !== comentario.content ? 1 : 0.7
                      }}
                      onClick={() => salvarEdicao(comentario.id)}
                    />
                  )}
                </div>
                {renderAttachments(attachments)}
              </div>
            ) : (
                <div>
                  <p style={{ fontFamily: 'Lato', whiteSpace: 'pre-wrap' }}>{comentario.content}</p>
                  {renderAttachments(attachments)}
                </div>
              )
          }
          actions={[
            responderId === null && editarId === null && depth === 0 && (
              <CommentAction onClick={() => setResponderId(comentario.id)}>
                <Auxiliar color={theme.colors.gray.Cinza_6}>
                  Responder
                </Auxiliar>
              </CommentAction>
          )].filter(Boolean)}
        >
          {comentario.replies && renderComments(
            comentario.replies,
            responderId,
            setResponderId,
            resposta,
            setResposta,
            adicionarResposta,
            cancelarResposta,
            editarId,
            setEditarId,
            textoEdicao,
            setTextoEdicao,
            salvarEdicao,
            cancelarEdicao,
            profileName,
            nomeUsuario,
            accordionId,
            setAccordionId,
            hoverId,
            setHoverId,
            excluirComentario,
            accordionRef,
            editTextareaRef,
            replySubmittingId,
            setReplySubmittingId,
            editSubmittingId,
            setEditSubmittingId,
            depth + 1
          )}
          {responderId === comentario.id && editarId === null && depth === 0 && (
            <S.ContainerInputCommentResponder>
              <S.NameProfile>
                <BodyMSpan>{profileName}</BodyMSpan>
              </S.NameProfile>

              <textarea
                value={resposta}
                onChange={e => {
                  setResposta(e.target.value);
                  const el = e.target;
                  el.style.height = 'auto';
                  el.style.height = Math.max(30, Math.min(el.scrollHeight, 200)) + 'px';
                }}
                onKeyDown={e => {
                  if (e.key === 'Enter') {
                    const target = e.target;
                    const start = target.selectionStart;
                    const end = target.selectionEnd;
                    if (e.ctrlKey || e.metaKey) {
                      e.preventDefault();
                      const value = target.value;
                      const newValue = value.slice(0, start) + '\n' + value.slice(end);
                      setResposta(newValue);
                      requestAnimationFrame(() => {
                        const pos = start + 1;
                        if (target.setSelectionRange) {
                          target.setSelectionRange(pos, pos);
                        }
                        target.style.height = 'auto';
                        target.style.height = Math.max(30, Math.min(target.scrollHeight, 200)) + 'px';
                      });
                      return;
                    }
                    e.preventDefault();
                    if (resposta.trim()) {
                      adicionarResposta(comentario.id);
                    }
                  }
                }}
                placeholder="Escreva uma resposta..."
                style={{ width: "70%", fontFamily: 'Lato', resize: 'none', minHeight: 30 }}
                rows={1}
              />

              <S.ContainerInputCommentOptions>
                <S.Close onClick={() => cancelarResposta(comentario.id)}>
                  <img src={IconCloseGray} alt="Ícone de fechar" />
                </S.Close>

                {replySubmittingId === comentario.id ? (
                  <S.LoadingComment />
                ) : (
                  <img
                    src={seta}
                    alt="seta"
                    style={{ 
                      width: '24px',
                      height: '24px',
                      cursor: resposta.trim() ? 'pointer' : 'not-allowed', 
                      opacity: resposta.trim() ? 1 : 0.7 }}
                    onClick={() => adicionarResposta(comentario.id)}
                  />
                )}
              </S.ContainerInputCommentOptions>
            </S.ContainerInputCommentResponder>
          )}

          {/* Opções do autor */}
          {isAuthor && isHovered && responderId === null && editarId === null && (
            <div style={{
              position: 'absolute',
              top: 0,
              right: 0,
              background: `${theme.colors.white.Branco}`,
              border: '1px solid #ccc',
              borderRadius: 4,
              zIndex: 10,
              padding: '4px 8px',
              cursor: 'pointer'
            }}
              onClick={() => setAccordionId(comentario.id)}
            >
              ...
            </div>
          )}

          {/* Accordion de opções */}
          {isAuthor && isAccordionOpen && responderId === null && editarId === null && (
            <div 
            ref={accordionRef}
            style={{
              position: 'absolute',
              top: 28,
              right: 0,
              background: `${theme.colors.white.Branco}`,
              border: '1px solid #ccc',
              borderRadius: 4,
              zIndex: 10,
              padding: '8px 12px',
              minWidth: 100,
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
            }}>
              <div
                style={{ cursor: 'pointer', marginBottom: 8 }}
                onClick={() => {
                  setEditarId(comentario.id);
                  setTextoEdicao(comentario.content);
                  setAccordionId(null);
                }}
              >
                <img src={penEditComment} alt="editar" style={{ width: 16, height: 16, marginRight: 4 }}/>

                <BodyMSpan>Editar</BodyMSpan>
              </div>
              <div
                style={{ cursor: 'pointer', color: 'red' }}
                onClick={() => {
                  excluirComentario(comentario.id);
                  setAccordionId(null);
                }}
              >
                <img src={deletIcon} alt="deletar" style={{ width: 16, height: 16, marginRight: 4 }}/>

                <BodyMSpan color={theme.colors.red.Vermelho_erro}>Excluir</BodyMSpan>
              </div>
            </div>
          )}
        </Comment>
      </div>
    );
  });
}

const CommentSection = ({ resourceType = 'calendar', resourceId }) => {
  const [comentarios, setComentarios] = useState([]);
  const [novoComentario, setNovoComentario] = useState('');
  const [responderId, setResponderId] = useState(null);
  const [resposta, setResposta] = useState('');
  const [editarId, setEditarId] = useState(null);
  const [textoEdicao, setTextoEdicao] = useState('');
  const [profileName, setProfileName] = useState('');
  const [accordionId, setAccordionId] = useState(null);
  const [hoverId, setHoverId] = useState(null);
  const accordionRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileName, setSelectedFileName] = useState('');
  const [selectedFileError, setSelectedFileError] = useState('');
  const [selectedPreviewUrl, setSelectedPreviewUrl] = useState('');
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const fileInputRef = useRef(null);
  const novoComentarioRef = useRef(null);
  const [replySubmittingId, setReplySubmittingId] = useState(null);
  const [editSubmittingId, setEditSubmittingId] = useState(null);
  const editTextareaRef = useRef(null);

  const normalizedResourceType = (resourceType || '').trim();
  const normalizedResourceId = Number(resourceId);
  const canLoad = Boolean(
    normalizedResourceType &&
    Number.isInteger(normalizedResourceId) &&
    normalizedResourceId > 0
  );

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('@userinfo'));
    if (user && user.name) {
      const nameParts = user.name.split(' ').filter(name => name.length > 0);
      let initials;
      if (nameParts.length >= 2) {
        initials = nameParts[0][0] + nameParts[1][0];
      } else {
        initials = nameParts[0].substring(0, 2);
      }
      initials = initials.toUpperCase();
      setProfileName(initials);
    }
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        accordionId !== null &&
        accordionRef.current &&
        !accordionRef.current.contains(event.target)
      ) {
        setAccordionId(null);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [accordionId]);

  useEffect(() => {
    let isActive = true;

    if (!canLoad) {
      setComentarios([]);
      return undefined;
    }

    const fetchComments = async () => {
      setIsLoading(true);
      try {
        const response = await api.get('/comments', {
          params: {
            resourceType: normalizedResourceType,
            resourceId: normalizedResourceId,
          },
        });
        if (isActive) {
          setComentarios(Array.isArray(response.data) ? response.data : []);
        }
      } catch (error) {
        console.error('Erro ao carregar comentarios:', error);
        if (isActive) {
          setComentarios([]);
        }
      } finally {
        if (isActive) {
          setIsLoading(false);
        }
      }
    };

    fetchComments();

    return () => {
      isActive = false;
    };
  }, [canLoad, normalizedResourceId, normalizedResourceType]);

  useEffect(() => {
    return () => {
      if (selectedPreviewUrl) {
        URL.revokeObjectURL(selectedPreviewUrl);
      }
    };
  }, [selectedPreviewUrl]);

  const resetSelectedFile = () => {
    setSelectedFile(null);
    setSelectedFileName('');
    setSelectedFileError('');
    setSelectedPreviewUrl('');

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files && event.target.files[0];
    if (!file) return;

    setSelectedFileError('');

    let normalizedFile = file;
    try {
      normalizedFile = await compressImageFile(file);
    } catch (error) {
      normalizedFile = file;
    }

    if (normalizedFile.size > MAX_UPLOAD_BYTES) {
      setSelectedFile(null);
      setSelectedFileName('');
      setSelectedPreviewUrl('');
      setSelectedFileError('Arquivo maior que 10 MB.');
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      return;
    }

    setSelectedFile(normalizedFile);
    setSelectedFileName(normalizedFile.name);

    if (normalizedFile.type && normalizedFile.type.startsWith('image/')) {
      setSelectedPreviewUrl(URL.createObjectURL(normalizedFile));
    } else {
      setSelectedPreviewUrl('');
    }
  };

  const handlePickFile = () => {
    if (!canLoad || isSubmitting) return;
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const nomeUsuario = USERJSON?.name || 'Usuário';

  const adicionarComentario = async () => {
    const content = novoComentario.trim();
    if (!canLoad || !content || isSubmitting || selectedFileError) return;

    setIsSubmitting(true);

    try {
      let response;

      if (selectedFile) {
        const formData = new FormData();
        formData.append('resourceType', normalizedResourceType);
        formData.append('resourceId', String(normalizedResourceId));
        formData.append('content', content);
        formData.append('file', selectedFile);

        response = await api.post('/comments', formData);
      } else {
        response = await api.post('/comments', {
          resourceType: normalizedResourceType,
          resourceId: String(normalizedResourceId),
          content,
        });
      }

      if (isLimitExceededPayload(response.data)) {
        setShowUpgradeModal(true);
        return;
      }

      setComentarios(prev => [...prev, response.data]);
      setNovoComentario('');
      resetSelectedFile();
      if (novoComentarioRef.current) {
        novoComentarioRef.current.style.height = 'auto';
      }
    } catch (error) {
      store.addNotification({
        title: 'Erro!',
        message: identifyErrorMenssage(error),
        type: 'danger',
        insert: 'top',
        container: 'top-right',
        animationIn: ['animated', 'fadeIn'],
        animationOut: ['animated', 'fadeOut'],
        dismiss: { duration: 4000, onScreen: true },
      });

      if (isLimitExceededPayload(error?.response?.data)) {
        setShowUpgradeModal(true);
        return;
      }
      if (error?.response?.status === 413) {
        setSelectedFile(null);
        setSelectedFileName('');
        setSelectedPreviewUrl('');
        setSelectedFileError('Arquivo maior que 10 MB.');
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        return;
      }
      console.error('Erro ao adicionar comentario:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const adicionarResposta = async (id) => {
    const content = resposta.trim();
    if (!canLoad || !content || replySubmittingId !== null) return;
    try {
      setReplySubmittingId(id);
      const response = await api.post('/comments', {
        resourceType: normalizedResourceType,
        resourceId: String(normalizedResourceId),
        parentId: String(id),
        content,
      });
      setComentarios(prev => adicionarRespostaRecursivo(prev, id, response.data));
      setResposta('');
      setResponderId(null);
    } catch (error) {
      console.error('Erro ao responder comentario:', error);
    } finally {
      setReplySubmittingId(null);
    }
  };

  const cancelarResposta = () => {
    setResponderId(null);
    setResposta('');
  };

  const salvarEdicao = async (id) => {
    if (!canLoad || !textoEdicao.trim() || editSubmittingId !== null) return;
    try {
      setEditSubmittingId(id);
      await api.put(`/comments/${id}`, { content: textoEdicao });
      setComentarios(prev => editarComentarioRecursivo(prev, id, textoEdicao));
      setEditarId(null);
      setTextoEdicao('');
    } catch (error) {
      console.error('Erro ao editar comentario:', error);
    } finally {
      setEditSubmittingId(null);
    }
  };

  const cancelarEdicao = () => {
    setEditarId(null);
    setTextoEdicao('');
  };

  const excluirComentario = async (id) => {
    if (!canLoad) return;
    try {
      await api.delete(`/comments/${id}`);
      const response = await api.get('/comments', {
        params: {
          resourceType: normalizedResourceType,
          resourceId: normalizedResourceId,
        },
      });
      setComentarios(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error('Erro ao excluir comentario:', error);
    }
  };

  const inputDisabled = !canLoad || isLoading || isSubmitting;
  const canSendComment = Boolean(novoComentario.trim() && canLoad && !isSubmitting && !selectedFileError);

  useEffect(() => {
    if (editarId !== null && editTextareaRef.current) {
      const el = editTextareaRef.current;
      el.style.height = 'auto';
      el.style.height = Math.max(30, Math.min(el.scrollHeight, 200)) + 'px';
    }
  }, [editarId, textoEdicao]);

  return (
    <S.Container>
      <ModalTesteGratisAcabou
        show={showUpgradeModal}
        onHide={() => setShowUpgradeModal(false)}
      />

      <H6>Comentários</H6>

      {comentarios.length > 0 && (
        <div style={{ width: '100%', height: 'auto' }}>
          {renderComments(
            comentarios,
            responderId,
            setResponderId,
            resposta,
            setResposta,
            adicionarResposta,
            cancelarResposta,
            editarId,
            setEditarId,
            textoEdicao,
            setTextoEdicao,
            salvarEdicao,
            cancelarEdicao,
            profileName,
            nomeUsuario,
            accordionId,
            setAccordionId,
            hoverId,
            setHoverId,
            excluirComentario,
            accordionRef,
            editTextareaRef,
            replySubmittingId,
            setReplySubmittingId,
            editSubmittingId,
            setEditSubmittingId,
            0
          )}
        </div>
      )}

          {responderId === null && editarId === null && (
        <>
          <S.ContainerInputComment>
            <S.NameProfile>
              <BodyMSpan>{profileName}</BodyMSpan>
            </S.NameProfile>

            <textarea
              ref={novoComentarioRef}
              value={novoComentario}
              onChange={e => {
                setNovoComentario(e.target.value);
                const el = e.target;
                el.style.height = 'auto';
                el.style.height = Math.max(30, Math.min(el.scrollHeight, 200)) + 'px';
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  const target = e.target;
                  const start = target.selectionStart;
                  const end = target.selectionEnd;
                  if (e.ctrlKey || e.metaKey) {
                    e.preventDefault();
                    const value = target.value;
                    const newValue = value.slice(0, start) + '\n' + value.slice(end);
                    setNovoComentario(newValue);
                    requestAnimationFrame(() => {
                      const pos = start + 1;
                      if (target.setSelectionRange) {
                        target.setSelectionRange(pos, pos);
                      }
                      target.style.height = 'auto';
                      target.style.height = Math.max(30, Math.min(target.scrollHeight, 200)) + 'px';
                    });
                    return;
                  }
                  e.preventDefault();
                  if (canSendComment) {
                    adicionarComentario();
                  }
                }
              }}
              placeholder={canLoad ? "Adicionar um comentario..." : "Salve o evento para habilitar comentarios..."}
              disabled={inputDisabled}
              style={{ fontFamily: 'Lato', width: '70%', resize: 'none', minHeight: 30, }}
              rows={1}
            />

            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              disabled={inputDisabled}
              style={{ display: 'none' }}
            />

            <S.ContainerInputCommentOptions>
              <button
                type="button"
                onClick={handlePickFile}
                disabled={inputDisabled}
                style={{ background: 'none', border: 'none', padding: 0, cursor: inputDisabled ? 'not-allowed' : 'pointer' }}
              >
                <img src={iconClipGray} alt="anexar arquivo" width="24px" height="24px" />
              </button>

              {isSubmitting ? (
                <S.LoadingComment />
              ) : (
                <img
                  src={seta}
                  alt="seta"
                  style={{ 
                    width: '24px',
                    height: '24px',
                    cursor: canSendComment ? 'pointer' : 'not-allowed', 
                    opacity: canSendComment ? 1 : 0.7 }}
                  onClick={adicionarComentario}
                />
              )}
            </S.ContainerInputCommentOptions>
          </S.ContainerInputComment>

          {selectedFileError && (
            <span style={{ color: theme.colors.red.Vermelho_erro, fontFamily: 'Lato', fontSize: 12 }}>
              {selectedFileError}
            </span>
          )}

          {selectedFileName && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              {selectedPreviewUrl ? (
                <img src={selectedPreviewUrl} alt={selectedFileName} style={{ maxWidth: 80, borderRadius: 4 }} />
              ) : null}

              <span style={{ fontFamily: 'Lato', fontSize: 12 }}>{selectedFileName}</span>

              <S.Close onClick={resetSelectedFile}>
                <img src={IconCloseGray} alt="Remover arquivo" />
              </S.Close>
            </div>
          )}
        </>
      )}
    </S.Container>
  );
};

export default CommentSection;
